module.exports = __webpack_public_path__ + "img/sync.069cdc62.png";